export default __webpack_public_path__ + "static/media/ic7.16228e86.gif";